import { isPlatform } from '@ionic/react';
import { Skeleton } from '@mui/material';
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model'
import { IQuestOptions, IQuestionModel, IQuestionTypeModel, IQuestionnaireUIModel, sections } from 'models/QuestionType.Model';
import React, { useEffect, useRef, useState } from 'react'
import { Alert, Col, Modal, ModalBody, Row, Spinner } from 'reactstrap';
import CommonService from 'services/CommonService';
import { Dictionary, groupBy } from "underscore";
import YesNoQuestions from './questiontypes/YesNoQuestions';
import { CustomButton } from 'components/shared/CustomButton';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { decryptOrderId, encryptOrderId, getStatusIds } from '../../helpers/Helper';
import NoneQuestions from './questiontypes/NoneQuestions';
import PopupQuestions from './questiontypes/PopupQuestions';
import MultiSelectQuestions from './questiontypes/MultiSelectQuestions';
import { useParams, useSearchParams } from 'react-router-dom';
import SkeletonLoader from 'components/skeleton/Skeleton';
import { HelperConstant } from '../../helpers/HelperConstant';
import EnquiryServices from 'services/Enquiry.Services';

interface inputProps {
    data: IGetOrderSummaryModel | undefined,
    id: string,
    setShowError: any,
    showError: boolean,
    statsId: any
}

function Questionnaire({ data, id, statsId, setShowError, showError, ...rest }: inputProps) {
    const [questionnaireData, setQuestionnaireData] = useState<Array<IQuestionTypeModel>>([]);
    const [orderedQuestionaire, setOrderedQuestionaire] = useState<Dictionary<IQuestionTypeModel[]>>();
    const [fakeLoad, setFakeLoad] = useState<boolean>(false);
    const [requoteLoader, setRequoteLoader] = useState<boolean>(false);
    const [nextSection, setNextSection] = useState<number>(0);
    const [sectionObj] = useState<Array<sections>>([]);
    const [sectionArray] = useState<Array<number>>([0]);
    const [questionType] = useState<number>(0);
    const { encryptedId } = useParams<any>();
    const [dataSpliced, setDataSpliced] = useState<boolean>(false);
    const [searchParams] = useSearchParams();
    const dashboardStatusId = searchParams.get('dashboardStatusId') as any;
   let pendingIds = `${HelperConstant.StatusId.PENDING},${HelperConstant.StatusId.PUBLICRECALCULATION},${HelperConstant.StatusId.ADMINCRECALCULATION}`;

   let requoteIds =  `${HelperConstant.StatusId.INPROGRESS},${HelperConstant.StatusId.ASSIGNED},${HelperConstant.StatusId.REQUOTE},${HelperConstant.StatusId.DELAYED}`;

    useEffect(() => { setFakeLoad(fakeLoad) }, [fakeLoad]);

    const [orderData, setOrderData] = useState<Array<IQuestionModel>>([]);
    const [postOrderData, setPostOrderData] = useState<Array<IQuestionModel>>([]);
    const [index, setIndex] = useState<number>(0);
    const [slideIndex, setSlideIndex] = useState<number>(0);
    // const [showError, setShowError] = useState<boolean>(false);
    const [muliticlick, setMultiClick] = useState<boolean>(false);
    const [enabledvalues, setEnablesValues] = useState([0]);
    const [questionnaireUI, setQuestionnaireUI] = useState<Array<IQuestionnaireUIModel>>();
    const [questionTypes] = useState({ YES_OR_NO: "Yes_No", MULTI_SELECT: "Multi_Select", OPTION: "Option", NONE: 'None', POPUP: "Popup" });
    const [hideWarranty, setHideWarranty] = useState<boolean>(false);
    const [isWarrantNoSelected, setIsWarrantNoSelected] = useState<boolean>(false);
    const [warrantyVoidReason, setWarrantyVoidReason] = useState('');
    const [hideDetails, setHideDetails] = useState("");
    const [device, setDevice] = useState("");

    const windowTop = useRef(null) as any;
    const multiSelectRef = useRef(null) as any;
    const mySlides = useRef(null) as any;

    const navigationPrevRef = useRef(null) as any;
    const navigationNextRef = useRef(null) as any;

    const executeScroll = () => windowTop?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const clearAllSelectionAndSubmit = () => {
        questionnaireData.forEach((item, index) => {
            if (index > 0) {
                item.Questions.forEach(ques => {
                    ques.Response = false;
                });
            }
        });

        setMultiClick(true);
        submitOrderHandler();
    }

    const defaultDataHandler = (selectedQuestionsIndex: any, QuestionnaireData: any) => {
        let questions = QuestionnaireData?.Questionnaire?.Sections as Array<IQuestionTypeModel>;
        questions[selectedQuestionsIndex]?.Questions?.forEach((x) => {
            orderData.filter(y => y.QuestionnaireTypeEnumName == x.QuestionnaireTypeEnumName).forEach((y) => {
                if (x.Id == y.QuestionnaireTemplateId) {
                    let fIndex = postOrderData.findIndex(z => z?.QuestionnaireTemplateId == x?.Id);
                    const questionObject: IQuestionModel = bindQuestionModel(x, x.Selected);

                    if (fIndex === -1) {
                        postOrderData.push(questionObject);
                    } else {
                        postOrderData[fIndex] = questionObject;
                    }
                    setPostOrderData(postOrderData);
                }
            })
        })
    }

    const bindSelecteData = async (postOrderData: Array<any>, isHappen: boolean) => {
        let selectedData: any[] = [];
        for (let x of postOrderData) {
            if (x.QuestionnaireTypeEnumName == "ScreeningQuestion" && !isHappen) {
                x.Selected = ((x.Selected == true || x.Selected == null) ? false : true);
            }
            if (x.Selected == true && x.DisplayInList == true) {
                x.OrderId = 0;
                x.Version = data?.QuestionnaireResponse[0].Version;
                x.DofyGeoId = data?.DofyGeoId;
                selectedData.push(x);
            }
        }
        return selectedData;
    }

    const submitOrderHandler = () => {
        setRequoteLoader(true);
        let changedArray: any[] = [];
        let isHappen = false;
        orderData.forEach((x) => {
            if (x.Selected == false) {
                let removeItems = x?.IgnoreResponseIds?.split(',');
                removeItems?.forEach((y: string) => {
                    let fIndex = orderData.findIndex((x: { Identifier: number; }) => x?.Identifier == parseInt(y));
                    orderData.splice(fIndex, 1);
                });
            }
            if (x.QuestionnaireTypeEnumName == "ScreeningQuestion") {
                isHappen = true;
                x.Selected = ((x.Selected == true || x.Selected == null) ? false : true);
            }
            changedArray.push(x);
        });
        switchSelectionForScreen();

        bindSelecteData(changedArray, isHappen).then(res => {
            if (getStatusIds(parseInt(statsId ?? "")) == pendingIds) {
                EnquiryServices.AdminRecalculationOrder(res, encryptedId, false).then(res => {
                    if (res.status === 200) {
                        setRequoteLoader(false);
                        let orderId = encryptOrderId(res.data);
                        window.location.href = '/agent-ticket-view/' + encryptedId + "?dashboardStatusId=" + dashboardStatusId;
                    }
                }).catch(e => {
                    console.log(e);
                });
            }
            else {
                CommonService.postWithEntityandSingleQueryParam('Sell', 'RequoteOrder', res, "encryptedOrderId", encryptedId).then(res => {
                    if (res.status === 200) {
                        setRequoteLoader(false);
                        let orderId = encryptOrderId(res.data);
                        window.location.href = '/agent-ticket-view/' + encryptedId + "?dashboardStatusId=" + dashboardStatusId;
                    }
                }).catch(e => {
                    console.log(e);
                });
            }
        });
    }

    const switchSelectionForScreen = () => {
        var data: Array<IQuestionTypeModel> = [];
        var warrantyOptions: Array<IQuestionTypeModel> = [];
        questionnaireData?.forEach(question => {
            let list = question?.Questions?.filter(x => x.AnswerType === "Yes_No");
            list?.forEach(x => {
                data.push(x);
            });

            if (question?.QuestionnaireTypeEnumName === "DeviceAge" && hideWarranty) {
                let warrantyData = question?.Questions?.filter(x => x.AnswerType === "Option");
                warrantyData.forEach(ques => {
                    warrantyOptions.push(ques);
                })
            }
        });

        if (data?.length > 0) {
            data?.forEach(item => {
                if (!(item?.QuestionnaireTypeEnumName === "DeviceAge" && hideWarranty)) {
                    let index = postOrderData.findIndex((x: { QuestionnaireTemplateId: number; }) => x.QuestionnaireTemplateId === item.Id);
                    let selected = postOrderData[index]?.Selected == null ? false : (postOrderData[index]?.Selected == false ? true : false);

                    if (index >= 0) {
                        onCheckMarkHandler(item, selected)
                    }
                }
            });
        }
        if (warrantyOptions?.length > 0) {
            warrantyOptions?.forEach(item => {
                let selected = item.DisplayInList === true ? false : true;
                onCheckMarkHandler(item, selected)
            });
        }
    }

    useEffect(() => {
        reverseSwitchSelectionForScreen();
        if (isWarrantNoSelected) {
            sectionArray.pop();
            setSlideIndex(sectionArray.at(-1) as number);
        }
    }, []);

    const reverseSwitchSelectionForScreen = () => {
        var datas: Array<IQuestionTypeModel> = [];

        questionnaireData?.forEach(question => {
            let list = question?.Questions?.filter(x => x.AnswerType === "Yes_No");
            list?.forEach(x => {
                datas.push(x);
            });
        });

        if (datas?.length > 0) {
            datas?.forEach(item => {
                if (!(item?.QuestionnaireTypeEnumName === "DeviceAge" && hideWarranty)) {
                    let index = data?.QuestionnaireResponse?.findIndex((x: { QuestionnaireTemplateId: number; }) => x.QuestionnaireTemplateId === item.Id) as any;
                    let selected = data?.QuestionnaireResponse[index]?.Selected == null ? null : (data?.QuestionnaireResponse[index]?.Selected == false ? true : false);

                    if (index >= 0) {
                        onCheckMarkHandler(item, selected)
                    }
                }
            });
        }
    }

    const onYesNoChange = (value: boolean, question: IQuestionTypeModel, index: number) => {
        questionnaireData[0].Questions.forEach((item, ind) => (item.DisplayInList = ind > index ? value : item.DisplayInList));
        let nextSectionIndex = value == true && question?.NextQuestionNo > 0 ? 0 : questionnaireData.findIndex(x => x.QuestionnaireTypeId == question.NextQuestionNo);
        setNextSection(nextSectionIndex);
        calculateSectionArray(question?.NextQuestionNo, value, nextSectionIndex);
        setSlideIndex(0);
        setFakeLoad(!fakeLoad);
        onCheckMarkHandler(question, value);
        if (value == false) {
            spliceData();
            removeChildResponse(index);
            // dataSpliced.current = true;
        }
    }

    const spliceData = () => {
        let deleteOrderData = orderData.filter(x => x.QuestionnaireTypeEnumName == "ScreeningQuestion");
        let deletePostOrderData = postOrderData.filter(x => x.QuestionnaireTypeEnumName == "ScreeningQuestion");
        orderData.length = 0;
        postOrderData.length = 0;

        for (let res of deleteOrderData) {
            orderData.push(res);
        }

        for (let res of deletePostOrderData) {
            postOrderData.push(res);
        }

        setOrderData(orderData);
        setPostOrderData(postOrderData);

        questionnaireData.forEach((item, index) => {
            if (item.QuestionnaireTypeEnumName != "ScreeningQuestion") {
                item.Questions.forEach(ques => {
                    if (ques.Response == true) {
                        ques.Response = null;
                    }
                });
            }
        });
    }

    const removeChildResponse = (index: number) => {
        questionnaireData[0].Questions.forEach((item, ind) => {
            if (ind > index) {
                onCheckMarkHandler(item, null);
            }
        })
    }

    const onRadioChange = (value: boolean, question: IQuestionTypeModel) => {
        onCheckMarkHandler(question, value);
    }

    const onMultiSelectHandler = (value: boolean, question: IQuestionTypeModel) => {
        onCheckMarkHandler(question, value);
    }

    const calculateSectionArray = (sectionId: number, canshow: boolean, nextSectionIndex: number) => {
        sectionObj.forEach((x, ind) => {
            if (!canshow && nextSectionIndex == questionnaireData?.length - 1) {
                x.DisplayInList = ind > 0 ? false : true;
            }
            else if (canshow && nextSectionIndex != questionnaireData?.length - 1) {
                x.DisplayInList = true;
            }
            else {
                x.DisplayInList = (x.SectionId == sectionId) ? canshow : true;
            }
        });
    }

    const onCheckMarkHandler = (question: IQuestionTypeModel, checked?: any) => {
        const Id = question.Id;
        const fIndex = orderData.findIndex((it: { QuestionnaireTemplateId: number; }) => it.QuestionnaireTemplateId === Id);
        const pFIndex = postOrderData.findIndex((it: { QuestionnaireTemplateId: number; }) => it?.QuestionnaireTemplateId === Id);
        const questionObject: IQuestionModel = bindQuestionModel(question, checked);

        if (pFIndex === -1) {
            postOrderData.push(questionObject);
        } else {
            postOrderData[pFIndex] = questionObject;
        }
        if (fIndex === -1) {
            orderData.push(questionObject);
        } else {
            orderData[fIndex] = questionObject;
        }

        for (let res of orderData) {
            if (checked && res.QuestionnaireTypeEnumName == "ScreeningQuestion") {
                res.DisplayInList = true;
            }
        }

        setOrderData(orderData);
        setPostOrderData(postOrderData);
    }

    const bindQuestionModel = (question: IQuestionTypeModel, checked: any): IQuestionModel => {
        return {
            Id: 0,
            Name: question.DisplayName,
            AnswerType: question.AnswerType,
            QuestionnaireTypeEnumName: question.QuestionnaireTypeEnumName,
            QuestionnaireTemplateId: question.Id,
            Selected: checked,
            Response:null,
            Threshold: question.Threshold,
            RowOrder: question.RowOrder,
            Identifier: question.Identifier,
            ParentId: question.ParentId,
            DisableWarranty: question.DisableWarranty,
            AppreciateCalculation: question.AppreciateCalculation,
            DepreciateCalculation: question.DepreciateCalculation,
            QuestionnaireTypeId: question.QuestionnaireTypeId,
            IgnoreResponseIds: question.IgnoreResponseIds,
            OrderId: question.OrderId,
            NextQuestionNo: question.NextQuestionNo,
            DisplayInList: question.DisplayInList
        };
    }

    useEffect(() => {
        const obj = questionnaireData[index];

        const questionnaireUIModel = (obj: IQuestionTypeModel) => {
            const result: Array<IQuestionnaireUIModel> = [];
            if (obj && obj?.Questions) {
                const questions = obj.Questions;
                const yesOrNo = questions?.filter(it => it.AnswerType === questionTypes.YES_OR_NO);
                const multiSelect = questions?.filter(it => it.AnswerType === questionTypes.MULTI_SELECT);
                const noneItems = questions?.filter(it => it.AnswerType === questionTypes.NONE);
                const options: Array<IQuestOptions> = [];
                if (noneItems && noneItems.length > 0) {
                    for (const item of noneItems) {
                        const opts = questions?.filter(it => it.ParentId === item.Identifier && it.AnswerType === questionTypes.OPTION);
                        const optionsObj: IQuestOptions = {
                            QuestionName: item.Name,
                            Lists: opts,
                            QuestionnaireTypeDisplayName: item.QuestionnaireTypeEnumName,
                        }
                        options.push(optionsObj);
                    }
                }
                result.push({
                    QuestionnaireTypeDisplayName: obj.QuestionnaireTypeDisplayName,
                    Header: obj.DisplayName,
                    Yes_No: yesOrNo,
                    Multi_Select: multiSelect,
                    Options: options,
                    QuestionnaireTypeEnumName: obj.QuestionnaireTypeEnumName
                });
                for (const YES_OR_NO of yesOrNo) {
                    const fIndex = orderData.findIndex((it: { QuestionnaireTemplateId: number; }) => it.QuestionnaireTemplateId === YES_OR_NO.Id);

                    if (fIndex === -1) {
                        const indexedRes = bindQuestionModel(YES_OR_NO, null);
                        orderData.push(indexedRes);
                    }
                }
            }
            setQuestionnaireUI(result);
        }

        questionnaireUIModel(obj);
    }, [questionnaireData, questionTypes, index, orderData]);

    const onNextIndexChange = async (direction?: string, sliderIndex?: any, isValidSubmit?: boolean, questionType?: string) => {
        // if (slideIndex == 0) {
        //     let nxtIndex = sectionObj.find((x: { DisplayInList: boolean; SectionIndex: number; }) => x.DisplayInList == true && x.SectionIndex > slideIndex)?.SectionIndex as number;
        //     // sectionArray.push(nxtIndex);
        //     clearSelectedValues(nxtIndex);
        // }

        orderData.forEach((x) => {
            if (x.DisableWarranty == true && x.QuestionnaireTypeEnumName == "ScreeningQuestion") {
                if (x.Selected == false) {
                    setIsWarrantNoSelected(true);
                }
                else {
                    setIsWarrantNoSelected(false);
                }
            }
        });

        onSlideIndexChange(direction, sliderIndex, isValidSubmit, questionType);
    };

    // const clearSelectedValues = async (nextIndex: number) => {
    //     for (let i = 1; i < nextIndex; i++) {
    //         questionnaireData[i].Questions.forEach(item => {
    //             item.Response = false;
    //             onCheckMarkHandler(false, item);
    //         })
    //     }
    // }

    const onSlideIndexChange = async (direction?: string, sliderIndex?: any, isValidSubmit?: boolean, questionType?: string) => {
        const swiper = await mySlides.current;
        checkForWarranty();
        if (direction && direction === "next") {
            let isValid: boolean = validateTab(slideIndex);
            if (isValid) {
                let nextIndex = sectionObj.find(x => x.DisplayInList == true && x.SectionIndex > slideIndex)?.SectionIndex as number;
                nextIndex = nextIndex ? nextIndex : sectionObj.length - 1;
                if (questionType == "ScreeningQuestion") {
                    let screenResult = orderData.filter(x => x.Selected == false && x.QuestionnaireTypeEnumName == "ScreeningQuestion");
                    if (screenResult.length > 0 && !(device?.includes("gaming-console") || device?.includes("tv"))) {
                        if (screenResult[0]?.Name?.toLowerCase()?.includes("body")) {
                            setHideDetails("DeviceBodyDetails");
                            nextIndex = (swiper?.activeIndex + 1);
                        }

                        if (screenResult[0]?.Name?.toLowerCase()?.includes("screen") || screenResult[0]?.Name?.toLowerCase()?.includes("display")) {
                            setHideDetails("DeviceScreenDetails");
                            nextIndex = (swiper?.activeIndex + 1);
                        };

                        if (screenResult[0]?.Name?.toLowerCase()?.includes("warranty")) {
                            setHideDetails("");
                            nextIndex = (swiper?.activeIndex + 1);
                        };

                        // if (screenResult[0]?.Name?.toLowerCase()?.includes("error") ) {
                        //     setHideDetails("DeviceErrorDetails");
                        //     nextIndex = (swiper?.activeIndex + 1);
                        // };

                        if (screenResult[0]?.Name?.toLowerCase()?.includes("lense")) {
                            setHideDetails("DeviceLenseDetails");
                            nextIndex = (swiper?.activeIndex + 1);
                        };
                    }
                    else {
                        setHideDetails("");
                    }
                }

                if (nextIndex) {
                    defaultDataHandler(nextIndex, data);
                }
                sectionArray.push(nextIndex);
                setIndex(nextIndex);
                headerSwiperHandler("next");
                setShowError(false);
                setEnablesValues([...enabledvalues, nextIndex]);

                if (isWarrantNoSelected && isValidSubmit) {
                    setSlideIndex(questionnaireData?.length - 2);
                }
                else {
                    setSlideIndex(nextIndex);
                    swiper.slideTo(nextIndex);
                    setFakeLoad(!fakeLoad);
                }

                if (isValidSubmit) {
                    setMultiClick(true);
                    submitOrderHandler();
                    if (!isWarrantNoSelected) {
                        setSlideIndex(questionnaireData?.length - 1);
                    }
                }
            }
            else {
                setShowError(true);
                setTimeout(() => {
                    setShowError(false);
                }, 1000);
            }

        } else if (direction && direction === "prev") {
            sectionArray.pop();
            let prevIndex = sectionArray.at(-1) as number;
            setIndex(prevIndex);
            setSlideIndex(prevIndex);

            headerSwiperHandler("prev");
            swiper.slideTo(prevIndex);

        } else if (sliderIndex >= 0) {
            setSlideIndex(sliderIndex);
            setIndex(sliderIndex);
            swiper.slideTo(sliderIndex);
        }
        executeScroll();
    };

    const headerSwiperHandler = (direction: "next" | "prev") => {
        if (direction === "next") {
            (document.getElementById("navigation-next") as any).click();
        }
        else {
            (document.getElementById("navigation-prev") as any).click();
        }
    }

    useEffect(() => {
        if (data) {
            setDevice(data?.ProductTypeName);
        }
    }, [data]);

    const checkForWarranty = async () => {
        let appreciateData: any = [];

        questionnaireData.forEach(quest => {
            quest.Questions.forEach(ques => {
                if (ques.AppreciateCalculation === true && ques.DisableWarranty === true) {
                    appreciateData.push(ques);
                }
            })
        });

        let depreciateWarranty = orderData?.filter(x => x.DisableWarranty === true && x.Selected === true && x.DepreciateCalculation === true && x.QuestionnaireTypeEnumName != "ScreeningQuestion");
        let screeningQuestionWarranty = orderData?.filter(x => x.QuestionnaireTypeEnumName == "ScreeningQuestion" && x.DisableWarranty === true && x.Selected === false && x.AnswerType == "Yes_No");
        const today = new Date();
        const warrantyValid = questionnaireData.some((x) => {
            const endDate = x.EndDate ? new Date(x.EndDate) : null;

            if (endDate) {
                if (today <= endDate) {
                    return false;
                } else {
                    setWarrantyVoidReason('startDate');
                    return true;
                }
            } else {
                return false;
            }
        });

        let warranty = depreciateWarranty?.length > 0 || screeningQuestionWarranty?.length > 0 || warrantyValid ? true : false;
        if (warranty == true) {
            for (let res of orderData) {
                if (res.QuestionnaireTypeEnumName == "DeviceAge") {
                    let fIndex = orderData.findIndex(x => x.QuestionnaireTemplateId == res.QuestionnaireTemplateId);
                    orderData.splice(fIndex, 1);
                }
            }

            for (let res of postOrderData) {
                if (res.QuestionnaireTypeEnumName == "DeviceAge") {
                    let fIndex = postOrderData.findIndex(x => x.QuestionnaireTemplateId == res.QuestionnaireTemplateId);
                    postOrderData.splice(fIndex, 1);
                }
            }
        }
        setHideWarranty(warranty);
    };

    const validateTab = (index: any) => {
        let valid = true;
        if (questionnaireData[index]?.QuestionnaireTypeEnumName === "DeviceAge" && hideWarranty) {
            return valid;
        }
        var requiredQuestions = hideDetails ? questionnaireData[index]?.Questions?.filter(x => x.Required === true && x.QuestionnaireTypeEnumName != hideDetails && x.IsWarranty == true) : questionnaireData[index]?.Questions?.filter(x => x.Required === true && x.IsWarranty == true);
        if (requiredQuestions?.length > 0) {
            requiredQuestions.forEach(question => {
                let isValid = validateQuestion(question);
                if (isValid === false) {
                    valid = false;
                }
            });
        }
        return valid;
    };

    const validateQuestion = (question: IQuestionTypeModel) => {
        let valid = true;
        if (question.DisplayInList == true) {
            if (question.AnswerType !== questionTypes.NONE && question.AnswerType !== questionTypes.POPUP) {
                valid = orderData?.find(x => x.Identifier === question.Identifier)?.Selected !== null ? true : false;
            }
            else if (question.ParentId === 0) {
                valid = validateOptions(question);
            }
            else {
                let parentValid = orderData?.find(x => x.Identifier === question.ParentId)?.Selected !== false ? true : false;
                let childvalid = validateOptions(question);
                valid = parentValid === false ? true : childvalid;
            }
        }

        return valid;
    };

    const validateOptions = (question: IQuestionTypeModel) => {
        let valid = true;
        valid = orderData?.filter(x => x.ParentId === question.Identifier && x.Selected === true)?.length > 0 ? true : false;
        return valid;
    };

    const GroupData = (QuestionnaireData: any) => {
        let isCategoryChanged = (QuestionnaireData?.IsCategoryChanged != true);
        let not_selected = "not_selected";
        let questionnaire: any = [];
        let questions = QuestionnaireData?.Questionnaire.Sections as Array<IQuestionTypeModel>;
        let QuestionnaireResponse = QuestionnaireData?.QuestionnaireResponse as Array<IQuestionModel>;
        questions?.forEach((item, index) => {
            sectionObj.push({ SectionIndex: index, SectionId: item.QuestionnaireTypeId, DisplayInList: true } as sections);
        });

        questions?.forEach((gQuestion) => {
            gQuestion.Questions.forEach((rQuestion, index) => {
                let result = QuestionnaireResponse.find(x => x.QuestionnaireTemplateId === rQuestion.Id);
                let fIndex = orderData.findIndex(x => x.QuestionnaireTemplateId == rQuestion.Id);
                if (rQuestion.QuestionnaireTypeEnumName == "ScreeningQuestion") {
                    rQuestion.Response =(isCategoryChanged)? rQuestion.Response == not_selected ? null : !result ? true : false
                    :result?.Response;
                    rQuestion.Selected = rQuestion.Selected == not_selected ? null : !result ? true : false;
                    if ((rQuestion.Response == false || rQuestion.DisplayInList == false) && gQuestion.Questions[index + 1]) {
                        gQuestion.Questions[index + 1].Response = not_selected;
                        gQuestion.Questions[index + 1].Selected = not_selected;
                        gQuestion.Questions[index + 1].DisplayInList = false;
                    }

                    let data = bindQuestionModel(rQuestion, rQuestion.Selected);
                    if (fIndex == -1 && isCategoryChanged) {
                        orderData.push(data);
                    }
                    let nextSectionIndex = questions.findIndex(x => x.QuestionnaireTypeId == rQuestion.NextQuestionNo);
                    if (rQuestion.Selected == false && rQuestion?.NextQuestionNo > 0) {
                        setNextSection(nextSectionIndex);
                    }

                    calculateInitialSectionArray(rQuestion?.NextQuestionNo, rQuestion.Selected, nextSectionIndex, questions);
                    // let removeItems = rQuestion?.IgnoreResponseIds?.split(',');
                    // removeItems?.forEach((y: string) => {
                    //     let fIndex = gQuestion.Questions.findIndex(x => x.Identifier == parseInt(y));
                    //     if (gQuestion.Questions[fIndex]) {
                    //         gQuestion.Questions[fIndex].DisplayInList = false;
                    //     }
                    // });

                }
                else {
                    rQuestion.Response = (isCategoryChanged)?result?.Selected:result?.Response;
                    rQuestion.Selected = result?.Selected ?? null;
                    if (result != null) {
                        let data = bindQuestionModel(rQuestion, true);
                        if (fIndex == -1 && isCategoryChanged) {
                            orderData.push(data);
                        }
                    }
                }
            });
            questionnaire.push(gQuestion);

        });

        setQuestionnaireData(questionnaire);
        setOrderedQuestionaire(groupBy(questions ?? [], "QuestionnaireTypeName"));
        defaultDataHandler(0, QuestionnaireData);
    }

    const calculateInitialSectionArray = (sectionId: number, canshow: boolean, nextSectionIndex: number, questions: IQuestionTypeModel[]) => {
        sectionObj.forEach((x, ind) => {
            if (!canshow && nextSectionIndex == questions?.length - 1) {
                x.DisplayInList = ind > 0 ? false : true;
            }
            else if (canshow && nextSectionIndex != questions?.length - 1) {
                x.DisplayInList = true;
            }
            else {
                x.DisplayInList = (x.SectionId == sectionId) ? canshow : true;
            }
        })
    }

    useEffect(() => {
        if (data) {
            GroupData(data);
        }
    }, [data]);


    return (
        <React.Fragment>
            <div ref={windowTop}>
                <Modal isOpen={requoteLoader} centered backdrop size='sm'>
                    <ModalBody>
                        <Row>
                            <Col className='text-center'>
                                <Spinner
                                    color="success"
                                    type="grow"
                                    className='me-3  align-middle'>
                                </Spinner>
                                <p className='my-1 text-dofy fw-semibold m-0'> Re-quote in progress...</p>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
                {questionnaireUI ?
                    <Row>
                        <Col>
                            {questionnaireData.length === 0 &&
                                Array.from({ length: 8 }).map((val, index) => (
                                    <Row key={index} className='justify-content-center'>
                                        <Col xl={10} className={'text-danger'} style={{ padding: (isPlatform("android") || isPlatform("ios")) ? "0px" : "0 25px" }}>
                                            <Skeleton></Skeleton>
                                        </Col>
                                    </Row>
                                ))}
                            <Row className='justify-content-center'>
                                <Col xl={10}>
                                    <Swiper
                                        spaceBetween={50}
                                        speed={400}
                                        allowTouchMove={false}
                                        slidesPerView={1}
                                        centeredSlides={true}
                                        observer={true}
                                        autoHeight={true}
                                        onSwiper={(swiper) => (mySlides.current = swiper)} style={{ boxShadow: "unset" }} className={`${fakeLoad}`} ref={mySlides} >
                                        {questionnaireData?.map((section: IQuestionTypeModel, sIndex: number) => {
                                            const parentQuestions = section?.Questions?.filter(question => question.ParentId === 0);
                                            return <SwiperSlide key={sIndex} className="mt-15 mb-15" >
                                                {(hideWarranty === true && section.QuestionnaireTypeEnumName === "DeviceAge") ?
                                                    <Row>
                                                        <Col className='text-center'>
                                                            {warrantyVoidReason === 'startDate'
                                                                ? <p className='text-dofy fw-semibold font-size-18'>Warranty Is Void Due to old device Content </p>
                                                                : <p className='text-dofy fw-semibold font-size-18'>Warranty Is Void</p>}
                                                        </Col>
                                                    </Row> :
                                                    <div>
                                                        <Row>
                                                            <Col className='text-center'>
                                                                <p className='text-muted fw-bold mb-2' style={{ fontSize: "15px" }}>{section.DisplayName}</p>
                                                            </Col>
                                                        </Row>
                                                        {/* {showError === true ?
                                                            <Alert color="warning" role="alert">
                                                                Select Any Options
                                                            </Alert>
                                                            // <Row>
                                                            //     <Col className='text-center'>
                                                            //         <p className='text-danger fw-bold'></p>
                                                            //     </Col>
                                                            // </Row> 
                                                            :
                                                            <></>} */}
                                                        <Row>
                                                            {parentQuestions?.map((item: IQuestionTypeModel, index: any) => {
                                                                return <Col xl={12}>
                                                                    {item && item.AnswerType === questionTypes.YES_OR_NO && item.DisplayInList == true && item.IsWarranty == true && (index == 0 ? true : orderData[index - 1]?.Selected != false) ?
                                                                        <YesNoQuestions isDummy={!(index == 0 ? true : orderData[index - 1]?.Selected != null)} orderData={orderData} data={section.Questions} item={item} index={index} elementRef={multiSelectRef} clickHandler={onYesNoChange} questionIndex={index}></YesNoQuestions> : <></>
                                                                    }
                                                                    {item && item.AnswerType === questionTypes.NONE ?
                                                                        <NoneQuestions hideDetails={hideDetails} data={section.Questions} item={item} index={index} elementRef={multiSelectRef} clickHandler={onRadioChange} ></NoneQuestions> : <></>
                                                                    }
                                                                    {item && item.AnswerType === questionTypes.POPUP ?
                                                                        <PopupQuestions data={section.Questions} item={item} index={index} elementRef={multiSelectRef} clickHandler={onRadioChange}></PopupQuestions> : <></>
                                                                    }
                                                                    {item && item.AnswerType === questionTypes.MULTI_SELECT ?
                                                                        <MultiSelectQuestions data={section.Questions} item={item} index={index} elementRef={multiSelectRef} response={orderData} clickHandler={onMultiSelectHandler}></MultiSelectQuestions> : <></>
                                                                    }
                                                                </Col>
                                                            })}

                                                        </Row>
                                                    </div>
                                                }
                                            </SwiperSlide>
                                        })}
                                    </Swiper>
                                </Col>
                            </Row>
                        </Col>
                        <Col className='text-center mt-2' xl={12}>
                            {slideIndex !== 0 &&
                                <CustomButton color="white" className="sell-devices-btn-back" onClick={() => onSlideIndexChange("prev", undefined, undefined, questionnaireData[slideIndex].QuestionnaireTypeEnumName)} type={'button'} btnClassName={'btn-secondary me-3 '} iconClasssName={undefined} name={'Back'} />
                            }
                            {
                                (nextSection === questionnaireData.length - 1) ?
                                    <CustomButton disabled={muliticlick} type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Finish'} onClick={() => clearAllSelectionAndSubmit()} /> :
                                    (isWarrantNoSelected ? slideIndex === (questionnaireData.length - 2) : slideIndex === (questionnaireData.length - 1)) ?

                                        <CustomButton disabled={muliticlick} type={undefined} btnClassName={'btn-success'} iconClasssName={undefined} name={'Finish'}
                                            onClick={() => onSlideIndexChange("next", undefined, true, questionnaireData[slideIndex].QuestionnaireTypeEnumName)} /> :
                                        <CustomButton type={'button'} btnClassName={'btn-info'} iconClasssName={undefined} name={'Continue'} onClick={() => onNextIndexChange("next", undefined, undefined, questionnaireData[slideIndex]?.QuestionnaireTypeEnumName)} />
                            }
                            <div ref={navigationNextRef} id="navigation-next" />
                            <div ref={navigationPrevRef} id="navigation-prev" />
                        </Col>
                    </Row>
                    : SkeletonLoader('12', '12')}
            </div>
        </React.Fragment>
    )
}

export default Questionnaire
